import { createSlice } from '@reduxjs/toolkit'


const billing = createSlice({
    name: 'billing',
    initialState: {
        company: null,//Общая информация о биллинге в компании
        transaction: null //Список неоплаченных транзакций
    },
    reducers: {
        companySet(state, action) {
            state.company = action.payload.data;
        },
        transactionSet(state, action) {
            state.transaction = action.payload.data;
        }

    }
})

export const { companySet, transactionSet } = billing.actions
export default billing.reducer